import React from "react";

import { handleClick, venueLink } from "./helpers";

const footerPrice = props => {
  const { footerNotes, lmd, price } = props;
  const fromText = lmd ? "as low as" : "from";
  const suffix = lmd ? (<em>per person</em>) : null;

  return (
    <p>
      {footerNotes && <span>{footerNotes}</span>}
      <em>{fromText}</em> <strong>£{price}</strong>
      {suffix}
    </p>
  );
};

const PackageFooter = props => {
  const link = venueLink(props);
  return (
    <footer className="full-width">
      {footerPrice(props)}
      {!props.isBookOnline && props.fallbackNumber && props.fallbackNumberHref &&
        <a
          href={`tel:${props.fallbackNumberHref}`}
          className="button button--small button--alt--solid gtm-track-click"
          role="button"
          data-gtm-category="Region Page"
          data-gtm-action="CTA"
          data-gtm-label="Call"
        >
          <i className="fas fa-phone fa-fw"></i>
          <span> Call {props.fallbackNumber} now </span>
        </a>
        }
      {props.isBookOnline &&
        <a
          className="button button--online button--strong"
          href={`${link}#offers`}
          role="button"
          onClick={handleClick("More Info Btn", link)}
        >
          <span> SEE ONLINE OFFERS </span>
        </a>
        }
      <a
        className="button button--alt button--strong"
        href={link}
        role="button"
        onClick={handleClick("More Info Btn", link)}
      >
        See More info<span className="offscreen">rmation on {props.venueName}</span>
      </a>

    </footer>
  );
};

export default PackageFooter;



// WEBPACK FOOTER //
// ./components/search/package/PackageFooter.jsx